import { CAMPAIGN_TYPE } from "V2.0/HomePages/Campaigns/BulkCampaigns/BulkCampaignCreate";

function getFollowUpSettingForCampaignType(campaignType, followUpSetting) {
  switch (campaignType) {
    case CAMPAIGN_TYPE.SMS:
      return {
        followUpDelay: followUpSetting?.followUpDelay || "",
        followUpMessage: followUpSetting?.followUpMessage || "",
      };
    case CAMPAIGN_TYPE.CALL:
      return {
        followUpDelay: followUpSetting?.followUpDelay || "",
      };
    case CAMPAIGN_TYPE.WHATSAPP:
      return {
        followUpDelay: followUpSetting?.followUpDelay || "",
        followUpTemplate: JSON.stringify({
          name: followUpSetting?.whatsAppFollowUp?.templateName || "",
          language: followUpSetting?.whatsAppFollowUp?.language || "",
        }),
      };
    default:
      return {};
  }
}

export function getFollowUpSettings(
  mode,
  itemIndexForEdit,
  followUpSettings,
  campaignType
) {
  let followUpSetting = {};

  if (mode === "edit") {
    followUpSetting = followUpSettings[itemIndexForEdit];
  }

  return getFollowUpSettingForCampaignType(campaignType, followUpSetting);
}
